import { createSlice } from '@reduxjs/toolkit';
import { Client } from 'webstomp-client';

interface PropsState {
    stompTXCB: Client | null;
    stompXD: Client | null;
    stompBC: Client | null;
    stompRH: Client | null;
}

export const socketSlice = createSlice({
    name: 'socket',
    initialState: {
        stompTXCB: null,
        stompXD: null,
        stompBC: null,
        stompRH: null,
    } as PropsState,
    reducers: {
        cacheStompTXCB(state, action) {
            state.stompTXCB = action.payload;
        },
        cacheStompXD(state, action) {
            state.stompXD = action.payload;
        },
        cacheStompBC(state, action) {
            state.stompBC = action.payload;
        },
        cacheStompRH(state, action) {
            state.stompRH = action.payload;
        },
    },
});

const { actions, reducer } = socketSlice;

export const { cacheStompTXCB, cacheStompXD, cacheStompBC, cacheStompRH } = actions;
export default reducer;
